module.exports = __webpack_public_path__ + "web/static/img/iridi_nest_logo.31b973ef.png";